/* eslint-disable */
export default {
      "settings@cookies.banner.accept_cta": 0,
      "settings@cookies.banner.body": 1,
      "settings@cookies.banner.settings_cta": 2,
      "settings@cookies.banner.title": 3,
      "settings@cookies.footer.cookie_policy": 4,
      "bumblesite@LAYOUT.FOOTER.MANAGE_COOKIES": 5,
      "mw@link.a11y.label.new-window": 6,
      "badoo_safety_center@breadcrumbs.a11y.label": 7,
      "badoo_safety_center@breadcrumbs.home.title": 8,
      "badoo_safety_center@footer.a11y.heading": 9,
      "badoo_safety_center@footer.copyright": 10,
      "badoo_safety_center@footer.cta.create_account": 11,
      "badoo_safety_center@footer.cta.get_the_app": 12,
      "badoo_safety_center@footer.legal_links.help": 13,
      "badoo_safety_center@footer.legal_links.press": 14,
      "badoo_safety_center@footer.legal_links.privacy": 15,
      "badoo_safety_center@footer.legal_links.terms": 16,
      "badoo_safety_center@footer.logo.a11y.label": 17,
      "badoo_safety_center@footer.logo.title": 18,
      "badoo_safety_center@footer.page_links.about": 19,
      "badoo_safety_center@footer.page_links.blog": 20,
      "badoo_safety_center@footer.page_links.careers": 21,
      "badoo_safety_center@footer.page_links.general": 22,
      "badoo_safety_center@footer.social_links.facebook": 23,
      "badoo_safety_center@footer.social_links.follow": 24,
      "badoo_safety_center@footer.social_links.instagram": 25,
      "badoo_safety_center@footer.social_links.twitter": 26,
      "badoo_safety_center@guide.text": 27,
      "badoo_safety_center@header.logo.a11y.label": 28,
      "badoo_safety_center@hero_block.title": 29,
      "badoo_safety_center@intro.video.stub.a11y.title": 30,
      "badoo_safety_center@more_guides.title": 31,
      "badoo_safety_center@navigation.close.a11y.label": 32,
      "badoo_safety_center@navigation.guides.title": 33,
      "badoo_safety_center@navigation.helplines.backward.a11y.label": 34,
      "badoo_safety_center@navigation.helplines.forward.a11y.label": 35,
      "badoo_safety_center@navigation.helplines.title": 36,
      "badoo_safety_center@navigation.main.a11y.label": 37,
      "badoo_safety_center@navigation.modal.a11y.label": 38,
      "badoo_safety_center@navigation.open.a11y.label": 39,
      "badoo_safety_center@navigation.tools.title": 40,
      "badoo_safety_center@navigation.updates.title": 41,
      "badoo_safety_center@page.not_found.cta": 42,
      "badoo_safety_center@page.not_found.text": 43,
      "badoo_safety_center@page.not_found.title": 44,
      "badoo_safety_center@page.search_results.not_found.block.cta": 45,
      "badoo_safety_center@page.search_results.not_found.block.cta.link": 46,
      "badoo_safety_center@page.search_results.not_found.block.list.item.one": 47,
      "badoo_safety_center@page.search_results.not_found.block.list.item.three": 48,
      "badoo_safety_center@page.search_results.not_found.block.list.item.two": 49,
      "badoo_safety_center@page.search_results.not_found.block.text": 50,
      "badoo_safety_center@page.search_results.not_found.block.text.note": 51,
      "badoo_safety_center@page.search_results.not_found.block.title": 52,
      "badoo_safety_center@page.search_results.not_found.title": 53,
      "badoo_safety_center@page.search_results.page.title": 54,
      "badoo_safety_center@search_field.clear.a11y.label": 55,
      "badoo_safety_center@search_field.placeholder.title": 56,
      "badoo_safety_center@search_field.submit.a11y.label": 57,
      "badoo_safety_center@seo.page.description.guides.section.harmful_behaviour": 58,
      "badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.fifth": 59,
      "badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.fourth": 60,
      "badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.three": 61,
      "badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.two": 62,
      "badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life": 63,
      "badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life.article.three": 64,
      "badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life.article.two": 65,
      "badoo_safety_center@seo.page.description.guides.section.mental_wellbeing": 66,
      "badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.fourth": 67,
      "badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.three": 68,
      "badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.two": 69,
      "badoo_safety_center@seo.page.description.guides.section.safety_tips": 70,
      "badoo_safety_center@seo.page.description.guides.section.safety_tips.article.fifth": 71,
      "badoo_safety_center@seo.page.description.guides.section.safety_tips.article.fourth": 72,
      "badoo_safety_center@seo.page.description.guides.section.safety_tips.article.three": 73,
      "badoo_safety_center@seo.page.description.guides.section.safety_tips.article.two": 74,
      "badoo_safety_center@seo.page.description.index": 75,
      "badoo_safety_center@seo.page.title.guides.section.harmful_behaviour": 76,
      "badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.fifth": 77,
      "badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.fourth": 78,
      "badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.three": 79,
      "badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.two": 80,
      "badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life": 81,
      "badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life.article.three": 82,
      "badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life.article.two": 83,
      "badoo_safety_center@seo.page.title.guides.section.mental_wellbeing": 84,
      "badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.fourth": 85,
      "badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.three": 86,
      "badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.two": 87,
      "badoo_safety_center@seo.page.title.guides.section.safety_tips": 88,
      "badoo_safety_center@seo.page.title.guides.section.safety_tips.article.fifth": 89,
      "badoo_safety_center@seo.page.title.guides.section.safety_tips.article.fourth": 90,
      "badoo_safety_center@seo.page.title.guides.section.safety_tips.article.three": 91,
      "badoo_safety_center@seo.page.title.guides.section.safety_tips.article.two": 92,
      "badoo_safety_center@seo.page.title.index": 93,
      "badoo_safety_center@store.app-store.a11y.label": 94,
      "badoo_safety_center@store.google-play.a11y.label": 95,
      "badoo_safety_center@tools.close.a11y.label": 96,
      "badoo_safety_center@tools.closeCta": 97,
      "badoo_safety_center@tools.cta": 98,
      "badoo_safety_center@tools.text": 99,
      "badoo_safety_center@updates.text": 100,
      "bumble_profile@safety_center.articles.safety_handbook.title": 101,
      "badoo_homepage@footer.language_selector.a11y.label": 102
} as const;
